import React from "react";
import PropTypes from "prop-types";
import Loader from "@src/components/atoms/Loader";
import AppUtils from "@src/utils/appUtils";
import CardContainer from "@src/components/cards/CardContainer";
import { useDCContext } from "@src/context";
import { AnimateNumberCount, ImageWithRetry } from "../../atoms";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

/** Currently unused, was for the Overview -> Impact section. */
const ManagersTotalSavingsCard = (props) => {
  const { value, fuel = true, isLoading = false } = props;
  const { getDynamicReplacement } = useDCContext();
  return (
    <CardContainer padding={0} shadow={false}>
      <div className="flex flex-col p-5 h-32">
        <div
          className={`bg-${fuel ? "yellow" : "teal"}-100 p-3 rounded-xl mb-2`}
          style={{ width: "fit-content" }}
        >
          {fuel ? (
            <span>
              <ImageWithRetry
                className="h-6 w-auto rounded-xl mr-2 inline"
                src={getDynamicReplacement(
                  "captain__events__behaviour__swiper__fuel_icon",
                )}
                alt="Fuel Savings"
              />
              <span className="text-yellow-600 font-bold">
                Total fuel saved:
              </span>
            </span>
          ) : (
            <span>
              <ImageWithRetry
                className="h-6 w-auto rounded-xl mr-2 inline"
                src={getDynamicReplacement(
                  "captain__events__behaviour__swiper__co2_icon",
                )}
                alt="Carbon Savings"
              />
              <span className="text-teal-600 font-bold">
                Total CO<sub>2</sub> saved:
              </span>
            </span>
          )}
        </div>
        {isLoading ? (
          <Loader size="lg" />
        ) : (
          <span className="text-black text-4xl font-medium">
            <AnimateNumberCount total={value} durationMS={600} />
          </span>
        )}
      </div>
    </CardContainer>
  );
};

export const managersTotalSavingsCardControls = {
  value: {
    propType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: "Savings value",
    disable: true,
  },
  fuel: {
    propType: PropTypes.bool,
    description: "Whether savings are fuel-related",
    controlType: "boolean",
    defaultValue: false,
  },
  getDynamicReplacement: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  isLoading: COMMON_CONTROLS.isLoading,
  className: COMMON_CONTROLS.className,
  industry: COMMON_CONTROLS.industry,
};
ManagersTotalSavingsCard.propTypes = AppUtils.getPropTypeFromControls(
  managersTotalSavingsCardControls,
);

export default ManagersTotalSavingsCard;
